import React from 'react';
import consentBoxStyles from './ConsentBox.module.scss';

export const ConsentBox: React.FC = () => {
  return (
    <>
      <div className={consentBoxStyles.consentBox}>
        <span dir="rtl">
          أقر بموجب هذا الإقرار على تمكين توال من جمع وتخزين واستخدام وأي معالجة أخرى لبياناتي
          الشخصية، وذلك وفقًا للسياسات والعمليات الداخلية ذات الصلة في توال وقوانين ولوائح حماية
          البيانات ذات الصلة في المملكة العربية السعودية.
        </span>
        <span dir="ltr">
          I hereby acknowledge to the collection, storage, usage, and any other processing of my
          personal data by TAWAL, in accordance with TAWAL&lsquo;s relevant internal policies and
          processes, and the relevant data protection laws and regulations in the Kingdom of Saudi
          Arabia.
        </span>
      </div>
    </>
  );
};
